import axios from 'axios';

export function resolveApiOrigin(env = process.env) {
  if (env.REACT_APP_API_URL) {
    return env.REACT_APP_API_URL;
  }
  if (env.NODE_ENV === 'production') {
    return '';
  }
  return 'http://localhost:8000';
}

const api = axios.create({
  baseURL: resolveApiOrigin(),
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export const getAuthConfig = async () => {
  const { data } = await api.get('/api/auth/config');
  return data;
};

export const getMe = async () => {
  const { data } = await api.get('/api/auth/me');
  return data;
};

export const devLogin = async () => {
  const { data } = await api.post('/api/auth/dev-login');
  return data;
};

export const logout = async () => {
  const { data } = await api.post('/api/auth/logout');
  return data;
};

export const fetchApps = async () => {
  const { data } = await api.get('/api/apps');
  return data;
};

export const fetchAppStatus = async () => {
  const { data } = await api.get('/api/apps/status');
  return data;
};

export const googleLoginUrl = (env = process.env) =>
  `${resolveApiOrigin(env)}/api/auth/google`;

export default api;
